import RefreshIcon from "@mui/icons-material/Refresh";
import { Box, styled, Switch, Tooltip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { ReactComponent as CreateIcon } from "../../../src/assets/USA_Images/CreateIcon.svg";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import HeaderToolbar from "../../components/HeaderToolbar";
import Toast from "../../components/ToastContainer/CustomToast";
import {
  getAllHealthQuestionarie,
  updateHealthQuestionarie,
} from "../../slices/HealthQuestionaries/HealthQuestionariesSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import DeleteChecklist from "../Checklist/DeleteChecklist";
import NoIcon from "../Checklist/YesNoSvg/Line.svg";
import yesIcon from "../Checklist/YesNoSvg/Tick.svg";
import EditIcon from "../Person/EditIcon";
import AddHealthQuestionaries from "./AddHealthQuestionaries";
import DeleteHealthQuestionaries from "./DeleteHealthQuestionaries";

const Android12Switch = styled(Switch)(({ mode, theme }) => ({
  padding: 8,
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    border: "1px solid #888B8D",
    backgroundColor: mode ? "#888B8D" : "white",
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: "#888B8D",
    boxShadow: "none",
    width: 16,
    height: 16,
    margin: 2,
    position: "relative",
    "&:before": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
    },
  },
  "& .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb": {
    backgroundColor: "#fff", // Change thumb color when checked
    "&:after": {
      content: '""',
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "60%",
      height: "60%",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="8" height="5.97" viewBox="0 0 8 5.97"><path fill="%23226BAB" d="M17.772,14.911l-3.381,3.381-1.353-1.352a.956.956,0,0,0-1.352,1.352l2.03,2.029a.955.955,0,0,0,1.352,0l4.057-4.057a.956.956,0,1,0-1.352-1.352Z" transform="translate(-11.405 -14.63)"/></svg>')`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundSize: "contain",
    },
  },
  "& .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#226BAB !important",
    opacity: 1,
  },
}));

export default function HealthQuestionaries(props) {
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [totalRecords, setTotalRecords] = useState(1);
  const [rows, setRows] = useState([]);
  const location = useLocation();
  const [openDeleteChecklistItem, setOpenDeletChecklistItem] = useState(false);
  const [checklitItemIDToDelete, setChecklitItemIDToDelete] = useState();
  const [checklitItem, setChecklitItem] = useState();
  const [isDisabled, setIsDisabled] = useState(false);
  const { setDiaLogBoxBlur } = useContext(ThemeContext);
  const { darkMode } = useContext(ThemeContext);

  const [paging, setPaging] = useState({
    page: 1,
    rowsPerPage: 50,
  });

  const [filter, setFilter] = React.useState({
    templateId: location.state.data.id,
    id: "",
    name: "",
  });

  const handleChange = (newPage, size) => {
    setPage(newPage);
    setPaging({
      page: newPage,
      rowsPerPage: size,
    });
  };

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("darkMode");
    } else {
      document.body.classList.remove("darkMode");
    }
    return () => {
      document.body.classList.remove("darkMode");
    };
  }, [darkMode]);

  useEffect(() => {
    loadData(filter, paging);
  }, [filter, paging]);

  const handleOpen = () => {
    setOpen(true);
    setDiaLogBoxBlur(true);
  };

  const handleClose = () => {
    setOpen(false);
    setDiaLogBoxBlur(false);
  };

  const loadData = (filter, paging) => {
    dispatch(getAllHealthQuestionarie(Object.assign(filter, paging)))
      .unwrap()
      .then((data) => {
        if ((data.code = "CVAI0000" && data.data)) {
          setTotalRecords(data.data.totalCount);
          setPage(data.data.curPage);
          setTotalPages(data.data.totalPages);
          setRows(data.data.questionaries);
        } else {
          setRows([]);
        }
      })
      .catch((er) => { });
  };

  const [selectedObject, setSelectedObject] = useState({
    id: "",
    companyId: "",
    question: "",
    options: "",
    expertedAnswer: "",
    isMandatory: true,
    disabled: false,
    templateId: location.state.data.id,
  });

  const handleChangeSwitch = (e, data) => {
    if (e.target.checked) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
    const payload = {
      id: data.id,
      question: data.question,
      options: data.options,
      expertedAnswer: data.expertedAnswer,
      mandatory: data.mandatory,
      templateId: location.state.data.id,
      isDisabled: e.target.checked ? false : true,
      opType: e.target.checked
        ? "Disable Checklist Item"
        : "Enable Checklist Item",
    };

    dispatch(updateHealthQuestionarie(payload))
      .unwrap()
      .then((data) => {
        handleClose(loadData(filter, paging));
        if (payload.isDisabled === false) {
          Toast(t("CHECK_LIST_ENABLED"), "success");
        } else if (payload.isDisabled === true) {
          Toast(t("CHECK_LIST_DISABLED"), "success");
        }
      });
  };

  const handleEditVisit = (params) => {
    if (params.disabled === true) {
      setOpenEditDialog(openEditDialog);
    } else {
      setOpenEditDialog(!openEditDialog);
      setDiaLogBoxBlur(true);
    }
    setSelectedObject(params);
  };

  const handleDeleteChecklistItem = (params) => {
    if (params.disabled === true) {
      setOpenEditDialog(openEditDialog);
    } else {
      setOpenDeletChecklistItem(!openDeleteChecklistItem);
      setDiaLogBoxBlur(true);
    }
    setChecklitItemIDToDelete(params.id);
    setChecklitItem(params);
  };

  const handleTextOverflow = (text) => {
    if (text && text.length > 20) {
      return text.substring(0, 20) + "...";
    } else {
      return text;
    }
  };
  const handleTextOverflow1 = (text) => {
    if (text && text.length > 10) {
      return text.substring(0, 10) + "...";
    } else {
      return text;
    }
  };
  const columns = React.useMemo(() => [
    {
      headerName: "",
      sortable: false,
      width: 5,
      renderCell: (params) => {
        return <div></div>;
      },
    },
    {
      field: "question",
      headerName: t("tableColumnHeaderItem"),
      flex: 1,
      width: 180,
      valueGetter: (params) => params.row.question,
      renderCell: (params) => (
        <Tooltip title={` ${params.value}`} placement="bottom-start">
          <span>{handleTextOverflow(params.value)}</span>
        </Tooltip>
      ),
    },

    {
      field: "options",
      headerName: t("slectLabeloptions"),
      flex: 1,
      minWidth: 100,
      valueGetter: (params) => params.row.options,
      renderCell: (params) => (
        <Tooltip title={` ${params.row.options}`} placement="bottom-start">
          <span>{handleTextOverflow1(params.row.options)}</span>
        </Tooltip>
      ),
    },

    {
      field: "expertedAnswer",
      headerName: t("EXPECTED_ANSWER"),
      flex: 1,
      width: 180,
      valueGetter: (params) => params.row.expertedAnswer,
      renderCell: (params) => (
        <Tooltip
          title={` ${params.row.expertedAnswer}`}
          placement="bottom-start"
        >
          <span>{handleTextOverflow(params.row.expertedAnswer)}</span>
        </Tooltip>
      ),
    },

    {
      field: "mandatory",
      headerName: t("tableColumnHeaderMandatory"),
      flex: 1,
      minWidth: 100,
      renderCell: (params) =>
        params.row.mandatory === "Yes" ? (
          <div>
            {" "}
            <img src={yesIcon} />{" "}
          </div>
        ) : params.row.mandatory === "No" ? (
          <div>
            <img src={NoIcon} />{" "}
          </div>
        ) : (
          params.row.mandatory
        ),
    },

    {
      field: "Actions",
      headerName: t("ACTION"),
      type: "actions",
      flex: 1,
      minWidth: 190,
      width: 150,
      headerAlign: "center",
      getActions: (params) => [
        <GridActionsCellItem
          icon={<EditIcon />}
          label="Edit"
          onClick={() => handleEditVisit(params.row)}
        />,

        <GridActionsCellItem
          icon={<DeleteChecklist />}
          label="Delete"
          onClick={() => handleDeleteChecklistItem(params.row)}
        />,

        <GridActionsCellItem
          icon={
            <Tooltip
              title={
                params.row.disabled === false
                  ? t("DISABLE_ITEM")
                  : t("ENABLE_ITEM")
              }
            >
              <Android12Switch
                checked={params.row.disabled ? false : true}
                mode={darkMode}
              />
            </Tooltip>
          }
          onChange={(e) => handleChangeSwitch(e, params.row)}
          sx={{
            "&:hover": {
              backgroundColor: "transparent", // Removes hover background
              cursor: "default", // Optional: Removes pointer cursor
            },
          }}
        />,
      ],
    },
  ]);

  return (
    <>
      <HeaderToolbar back_button={true} title={t("CHECKLIST003")} />
      <Box
        style={{
          display: "flex",
          flexDirection: "row-reverse",
          justifyContent: "flex-start",
          alignItems: "center",
          gap: "7px"
        }}>
        <Box
          style={{
            textAlign: "center",
            padding: "10px",
            backgroundColor: process.env.REACT_APP_BG_ICON,
            borderRadius: "50%",
            cursor: "pointer",
            position: "relative",
            bottom: "5px"
          }}
        >
          <Tooltip title={t("CHECKLIST002")}>
            <Box item className={"ADD_ACCESS"} onClick={handleOpen}>
              <CreateIcon />
            </Box>
          </Tooltip>
        </Box>

        <Tooltip title={t("COMMON002")}>
          <Box item className="refreshIcon">
            <RefreshIcon onClick={() => loadData(filter, paging)} />
          </Box>
        </Tooltip>
      </Box>
      <div style={{ height: 300, width: "100%", paddingTop: "5px" }}>
        <DataTableLatest
          columns={columns}
          rows={rows}
          page={page}
          count={totalRecords}
          rowId={(row) => row.id}
          pageCount={totalPages}
          pageSize={rowsPerPage}
          handleChange={(newPage, size) => handleChange(newPage, size)}
        />
      </div>
      {open && (
        <AddHealthQuestionaries
          selectedObject={selectedObject}
          templateId={location.state.data.id}
          open={open}
          handleClose={() => {
            handleClose(loadData(filter, paging));
            setDiaLogBoxBlur(false);
          }}
        />
      )}
      ,
      {openEditDialog && (
        <AddHealthQuestionaries
          selectedObject={selectedObject}
          open={openEditDialog}
          templateId={location.state.data.id}
          handleClose={() => {
            setOpenEditDialog(false);
            setDiaLogBoxBlur(false);
            setSelectedObject({
              id: "",
              name: "",
              companyId: "",
              description: "",
              question: "",
              options: "",
              expertedAnswer: "",
              isMandatory: true,
            });
            loadData(filter, paging);
          }}
        />
      )}
      ,
      {openDeleteChecklistItem && (
        <DeleteHealthQuestionaries
          open={openDeleteChecklistItem}
          handleClose={(data) => {
            setOpenDeletChecklistItem(data);
            handleClose(loadData(filter, paging));
            setDiaLogBoxBlur(false);
          }}
          DeleteId={checklitItemIDToDelete}
          checklitItem={checklitItem}
        />
      )}
    </>
  );
}
